<div
  class="ui-filedrop"
  [class.is-disabled]="disabled"
  [class.is-invalid]="invalid"
  [attr.data-over]="dragOver || null"
  (dragover)="onDragOver($event)"
  (dragleave)="onDragLeave($event)"
  (drop)="onDrop($event)"
  (click)="onClick()"
>
  <span class="ui-filedrop-ic"><i class="fas fa-cloud-upload-alt"></i></span>
  <b>{{ title }}</b>
  @if (hint) {
    <span>{{ hint }}</span>
  }
  @if (sizeLimit()) {
    <div>
      Размер файла(-ов) — <strong>{{ sizeLimitDisplay() }}</strong>
    </div>
  }
  <input
    type="file"
    [multiple]="multiple"
    [accept]="accept"
    (change)="onInputChange($event)"
    hidden
    #fileInput
  />
</div>
